import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 20px;
`

export const ActionsWrapper = styled.div`
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
`
